import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "table table-bordered mt-4 mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "fw-bold mb-4"
}
const _hoisted_6 = { class: "row mt-3" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "row mt-3" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-sm-6" }
const _hoisted_15 = { class: "d-flex align-items-center mt-3" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_19 = { key: 2 }
const _hoisted_20 = {
  key: 2,
  class: "d-flex justify-content-end mt-3"
}
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_select_genders = _resolveComponent("select-genders")!
  const _component_select_garment_properties = _resolveComponent("select-garment-properties")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.estimationBaseInformation.isIndustrialProduct)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.estimationBaseInformation.isStandaloneIndustrialProduct)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_form_field, {
                    type: "select-string",
                    labelKey: "Size",
                    labelValue: "Size",
                    placeholderKey: "Select a size",
                    placeholderValue: "Select a size",
                    needSorting: false,
                    list: _ctx.estimationBaseInformation.industrialProductSizes,
                    modelValue: _ctx.estimationBaseInformation.industrialProductSize,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.estimationBaseInformation.industrialProductSize) = $event)),
                    disabled: _ctx.isReadOnly
                  }, null, 8, ["list", "modelValue", "disabled"])
                ])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "You selected an industrial product. You cannot edit the informations.",
                  text: "You selected an industrial product. You cannot edit the informations.",
                  type: "strong"
                }),
                _createElementVNode("table", _hoisted_4, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Type",
                          text: "Type"
                        })
                      ]),
                      _createElementVNode("th", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Size",
                          text: "Size"
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.estimationBaseInformation.industrialProductType), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.estimationBaseInformation.industrialProductSize), 1)
                    ])
                  ])
                ])
              ], 64))
        ]))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.estimationBaseInformation.garmentPropertyLayers, (garmentLayer, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "mb-4",
            key: index
          }, [
            (_ctx.estimationBaseInformation.garmentPropertyLayers.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("h4", null, _toDisplayString(garmentLayer.garmentLayerName), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createBlock(_component_select_genders, {
                  modelValue: garmentLayer,
                  index: index,
                  garmentConfiguration: _ctx.garmentConfiguration,
                  key: 'gender_' + garmentLayer.garmentLayerName + '_' + index,
                  "onUpdate:modelValue": ($event: any) => (_ctx.estimationBaseInformation[index] = $event),
                  onValueUpdated: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateGenderForBothGarmentLayer($event))),
                  isReadOnly: _ctx.isReadOnly
                }, null, 8, ["modelValue", "index", "garmentConfiguration", "onUpdate:modelValue", "isReadOnly"]))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_form_field, {
                  type: "number",
                  labelKey: "Wastage Percentage",
                  labelValue: "Wastage Percentage",
                  placeholderKey: "Wastage Percentage",
                  placeholderValue: "Wastage Percentage",
                  modelValue: _ctx.bothWastagePercentage,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bothWastagePercentage) = $event)),
                  readonly: _ctx.isReadOnly
                }, null, 8, ["modelValue", "readonly"])
              ])
            ]),
            (garmentLayer.gender)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(), _createBlock(_component_select_garment_properties, {
                        modelValue: garmentLayer,
                        index: index,
                        key: 'prop' + garmentLayer.garmentLayerName + '_' + index + '_' + garmentLayer.gender,
                        garmentConfiguration: _ctx.garmentConfiguration,
                        "onUpdate:modelValue": ($event: any) => (_ctx.updateGarmentLayer($event, index)),
                        onEUSizeChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateEUSizeForBothGarmentLayer($event))),
                        isReadOnly: _ctx.isReadOnly
                      }, null, 8, ["modelValue", "index", "garmentConfiguration", "onUpdate:modelValue", "isReadOnly"]))
                    ])
                  ]),
                  (_ctx.garmentConfiguration.hasExtraPockets)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Do you have any extra pockets?",
                              text: "Do you have any extra pockets?",
                              class: "fw_700"
                            }),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["btn me-2", _ctx.hasExtraPockets ? 'btn-tertiary' : 'btn-secondary withBorder']),
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hasExtraPockets = true)),
                                disabled: _ctx.isReadOnly
                              }, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Yes",
                                  text: "Yes"
                                })
                              ], 10, _hoisted_16),
                              _createElementVNode("button", {
                                class: _normalizeClass(["btn", !_ctx.hasExtraPockets ? 'btn-tertiary' : 'btn-secondary withBorder']),
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hasExtraPockets = false)),
                                disabled: _ctx.isReadOnly
                              }, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "No",
                                  text: "No"
                                })
                              ], 10, _hoisted_17)
                            ])
                          ]),
                          (_ctx.hasExtraPockets)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createVNode(_component_form_field, {
                                  type: "number",
                                  labelKey: "Number of extra pockets",
                                  labelValue: "Number of extra pockets",
                                  placeholderKey: "Number of extra pockets",
                                  placeholderValue: "Number of extra pockets",
                                  modelValue: _ctx.estimationBaseInformation.extraPocketsNumber,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.estimationBaseInformation.extraPocketsNumber) = $event)),
                                  readonly: _ctx.isReadOnly
                                }, null, 8, ["modelValue", "readonly"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "You have to select gender",
                    text: "You have to select gender"
                  })
                ]))
          ]))
        }), 128)),
    (!_ctx.isReadOnly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("button", {
            class: "btn btn-tertiary",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.editBaseInformation && _ctx.editBaseInformation(...args))),
            disabled: _ctx.disabled
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Continue",
              text: "Continue"
            })
          ], 8, _hoisted_21)
        ]))
      : _createCommentVNode("", true)
  ]))
}